import { Baby, Cake, GraduationCap, Heart, HeartStraight, Flower, Medal, Armchair, Compass, PencilSimple, Gift } from "@phosphor-icons/react";
import { GIFT_OCCASIONS } from "@/data/categories";

const ICONS = { Baby, Cake, GraduationCap, Heart, Flower, Medal, Armchair, Compass, PencilSimple };
const SHORT = { holiday: "Holiday Journal" };
const COLORS = ["#E06D53", "#36858B", "#D9A036", "#8C6CB0", "#4A8B6E", "#C85B7A"];

// Same true-square tiles on the homepage and the gift page.
export const OccasionGrid = ({ value, onPick, testPrefix = "gift-occasion", cols = "grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5" }) => (
  <div className={`grid gap-3 ${cols}`}>
    {GIFT_OCCASIONS.map((o, i) => {
      const Icon = o.id === "just-because" ? HeartStraight : ICONS[o.icon] || Gift;
      const on = value === o.id;
      return (
        <button key={o.id} type="button" data-testid={`${testPrefix}-${o.id}`} aria-pressed={on} onClick={() => onPick(o)}
          className={`flex aspect-square min-w-0 flex-col items-center justify-center gap-1.5 overflow-hidden rounded-2xl border-2 p-3 text-center transition-[transform,background-color,border-color] hover:-translate-y-0.5 ${on
            ? "border-[#E06D53] bg-[#FFF1E8] shadow-md"
            : "border-transparent bg-white shadow-sm hover:border-[#E06D53]/40"}`}>
          <Icon size={30} weight="duotone" className="shrink-0" style={{ color: on ? "#E06D53" : COLORS[i % COLORS.length] }} />
          <span className="w-full break-words font-serif text-sm leading-tight text-[#2D2824] min-[380px]:text-base">{SHORT[o.id] || o.label}</span>
          <span className="line-clamp-2 w-full text-xs leading-snug text-[#8A7F76]">{o.tagline}</span>
        </button>
      );
    })}
  </div>
);

export const OccasionPicker = ({ value, onPick, custom, onCustom }) => (
  <div data-testid="gift-occasion-picker">
    <p className="mb-2 text-sm font-medium text-[#2D2824]">Choose an occasion <span className="font-normal text-[#8A7F76]">(fills in a message you can edit)</span></p>
    <OccasionGrid value={value} onPick={onPick} />
    {value === "other" && (
      <input data-testid="gift-occasion-custom" maxLength={40} value={custom} onChange={(e) => onCustom(e.target.value)}
        placeholder="Name the occasion, e.g. Anniversary" autoFocus
        className="mt-3 w-full rounded-xl border border-[#EBE4DA] bg-white px-4 py-3 text-base focus:outline-none focus:ring-2 focus:ring-[#36858B]/40" />
    )}
  </div>
);
